export default __webpack_public_path__ + "static/media/ChaltenManual30.bf47df74.jpg";